// export const API_URL = 'http://localhost/liceo_morelia/calificaciones/api';
export const API_URL = 'https://calificaciones.liceomorelia.mx/api';
